/**
 * Placeholder copy for Royalties World empty / search-empty / load
 * states (APP-2083). The historical cut-off banner is not here — each region
 * owns its own Parameter Store keys in `constant/royaltiesHistoricalBanner`.
 *
 * Empty-state wording is a placeholder until Member Services sign-off.
 */

export const royaltiesWorldCopy = {
  /**
   * Shown when there are no finalised Royalties World rows (page 1, no
   * search). Must not imply an error or that money is owed.
   * TODO(APP-2083): Confirm copy with Member Services
   */
  emptyState: {
    description:
      'When Royalties World statements are available for this workspace, they will appear here.',
    title: 'No Royalties World statements yet',
  },
  /**
   * Compact in-card error when the list fetch fails with no prior page to keep.
   */
  loadError: {
    bodyAfterRetry: ' the page.',
    bodyBeforeRetry:
      "We couldn't load these statements. Try adjusting your search or ",
    title: 'Something went wrong.',
  },
  /**
   * Compact in-card error when a refresh fails but keepPreviousData still has
   * rows.
   */
  refreshError: {
    bodyAfterRetry: ' the page.',
    bodyBeforeRetry:
      "We couldn't refresh these statements. Showing the last loaded results — try adjusting your search or ",
    title: 'Something went wrong.',
  },
  /**
   * In-table empty copy when a search returns zero matches (keeps the search
   * field). Shared by Title and Earnings tables.
   */
  searchNoResultsEmpty: {
    description: "We couldn't find what you are looking for.",
    icon: 'search' as const,
    title: 'No results found',
  },
} as const;
